
import React from "react";
import { Navbar, Container, Image, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../styles/NavbarComp.css";

import logo from "../images/cvv-nvbar.png";
import meityLogo from "../images/meitylogo.png";
import amritaLogo from "../images/amritalogo.png";
import cdacLogo from "../images/cdac.png";
import '../css/main.css';

function NavbarComp() {
  const navigate = useNavigate();

  return (


<Navbar
  // bg="light"
    bg="navbar"
  expand="lg"
  className="shadow-sm py-2 custom-navbar"
  sticky="top"
  collapseOnSelect
  role="navigation"
  aria-label="Main navigation"
>
  <Container fluid className="px-4 d-flex justify-content-between align-items-center">
    
    <Navbar.Brand
      role="link"
      tabIndex={0}
      aria-label="Go to ChalaChithra Vaachana home page"
      onClick={() => navigate("/")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") navigate("/");
      }}
      className="d-flex align-items-center cursor-pointer"
    >
      <Image
        src={logo}
        alt="ChalaChithra Vaachana Logo"
        height="35"
        className="navbar-logo"
      />
      <span className="visually-hidden">ChalaChithra Vaachana Home</span>
    </Navbar.Brand>

    <div
      className="d-flex align-items-center gap-3"
      role="group"
      aria-label="Partner organization logos"
    >
      <Image
        src={meityLogo}
        alt="Logo: Ministry of Electronics and Information Technology, Government of India"
        height="40"
        className="navbar-icon"
      />
      <Image
        src={cdacLogo}
        alt="Logo: Centre for Development of Advanced Computing (C-DAC)"
        height="40"
        className="navbar-icon"
      />
      <Image
        src={amritaLogo}
        alt="Logo: Amrita Vishwa Vidyapeetham University"
        height="40"
        className="navbar-icon"
      />
    </div>

    
  </Container>
</Navbar>


  );
}

export default NavbarComp;


